import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../CSS/Styles/Typography.css';
import '../CSS/Styles/ColorTheme.css';
import '../CSS/Components/SideMenu.css';
import { getLandingPathForMenuItem } from '../utils/landingRoutes';

function SideMenu({ currentSection, toggleMenu, isMenuOpen, lastVideoSection, isHidden = false }) {
  const navigate = useNavigate();
  const menuItems = [
    { id: 'home', text: 'HOME', path: getLandingPathForMenuItem('home') },
    { id: 'services', text: 'SERVICES', targetId: 'services', path: getLandingPathForMenuItem('services') },
    { id: 'about', text: 'ABOUT', targetId: 'vision', path: getLandingPathForMenuItem('about') },
    { id: 'connect', text: 'CONNECT', path: getLandingPathForMenuItem('connect') }
  ];
  
  useEffect(() => {
    const sections = document.querySelectorAll('.menu-item'); // Use .menu-item to select by class
    const menuContainer = document.querySelector(".menu-container"); // Correct ID selection

    if (menuContainer) {
      console.log("Menu container found, running the code.");
      
      menuContainer.classList.remove("aboutMenu");
      console.log("ABOUITTTT");

      if (currentSection[1] === 'about') {
        menuContainer.classList.add("aboutMenu");
        console.log("is about");
      }
    } else {
      console.log("Menu container not found."); // Debugging output
    }

    const safeCurrentSection = currentSection[0] || "video0"; // fallback to "video1" or something safe

    const isLightSection =
      safeCurrentSection === "video0" ||
      safeCurrentSection === "video1" ||
      safeCurrentSection === "video2" ||
      safeCurrentSection === "video3" ||
      safeCurrentSection === "video4" ||
      safeCurrentSection === "home" ||
      safeCurrentSection === "services" ||
      safeCurrentSection === "ecom" ||
      safeCurrentSection === "vision" ||
      safeCurrentSection === "store" ||
      safeCurrentSection === "about";



    sections.forEach((section) => {
      section.classList.remove('white', 'black'); // Remove both classes first

      if (isMobileDevice() === false) {
        console.log(`CHECK SECTION: ${safeCurrentSection}`)
        if (isLightSection) {

          section.classList.add('white');
          console.log("is white");
        } else {
          section.classList.add('black');
          console.log("is black");
        }
        console.log(`currentSection ${currentSection[0]}`);
      }else{
        section.classList.add('white');
        console.log("is phone menu");

      }
    });

    function isMobileDevice() {
      return window.innerWidth <= 768; // Adjust this width based on your needs
    }

    // Clean up function (if needed)
    return () => {
      sections.forEach((section) => {
        section.classList.remove('white', 'black'); // Remove classes on cleanup
      });

      if (menuContainer) {
        menuContainer.classList.remove(
          "aboutMenu",
        );
      }

    };
  }, [currentSection]); // Add currentSection as a dependency

  useEffect(() => {
    const hash = window.location.hash.slice(1); // Get the hash without the #
    if (hash) {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  }, []);

  return (
    <nav className={`menu-container ${isMenuOpen ? "open" : "closed"} ${isHidden ? 'is-hidden' : ''}`} aria-label="Primary" aria-hidden={isHidden}>
      {menuItems.map(menuItem => (
        <a
          key={menuItem.id}
          href={menuItem.path}
          onClick={(e) => {
            if (isHidden) {
              e.preventDefault();
              return;
            }

            e.preventDefault(); // Prevent browser's default anchor scrolling
            navigate(menuItem.path);

            if (isMenuOpen) {
              toggleMenu();
            }

            const targetId = menuItem.id === 'home'
              ? (lastVideoSection || 'home')
              : (menuItem.targetId || menuItem.id);
            const targetSection = document.getElementById(targetId);

            if (targetSection) {
              targetSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start', // Ensures scrolls to the top of the section
              });
            }
          }}
          className={`menu-item ${currentSection[1]} ${currentSection[1] === menuItem.id ? 'active' : 'inactive'}`}
          tabIndex={isHidden ? -1 : 0}
        >
          {menuItem.text}
        </a>
      ))}
    </nav>
  );
}

export default SideMenu;